var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator['throw'](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = this && this.__generator || function (thisArg, body) {
    var _ = {
            label: 0,
            sent: function () {
                if (t[0] & 1)
                    throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
    return g = {
        next: verb(0),
        'throw': verb(1),
        'return': verb(2)
    }, typeof Symbol === 'function' && (g[Symbol.iterator] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f)
            throw new TypeError('Generator is already executing.');
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y['return'] : op[0] ? y['throw'] || ((t = y['return']) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [
                        op[0] & 2,
                        t.value
                    ];
                switch (op[0]) {
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [0];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2])
                        _.ops.pop();
                    _.trys.pop();
                    continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import React, {
    useEffect,
    useState
} from 'react';
import { inject } from 'mobx-react';
import {
    Button,
    Loader
} from 'oned';
import { withRouter } from 'react-router-dom';
import './index.less';
import { CommonBusiness } from '@business/newCreateRequest/common/common';
import { observer } from 'mobx-react-lite';
import { stepReviewBusiness } from '@business/newCreateRequest/stepsItems/review';
import { combine } from 'fe-toolkit';
import moment from 'moment';
import { HomeBusiness } from '@business/newCreateRequest/common/home';
import {
    AmplitudeEventName,
    WOStatus
} from '@common/enums/base';
import {
    getCurrentEnv,
    isIH,
    isMobile,
    sendAmplitude_Default
} from '@common/utils';
import Cookies from 'js-cookie';
var CreateRequestSubmitted = inject(combine(CommonBusiness, stepReviewBusiness, HomeBusiness))(observer(function (props) {
    var history = props.history, getWoDetail = props.getWoDetail, getIsEnableDTCConfig = props.getIsEnableDTCConfig, woDetail = props.woDetail, isDTC = props.isDTC, submitData = props.submitData, currentUser = props.currentUser, isRecallCheck = props.isRecallCheck;
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useState(), currentStep = _b[0], setCurrentStep = _b[1];
    var _c = useState([
            {
                id: 1,
                name: 'Request Submitted',
                completeTime: new Date()
            },
            {
                id: 2,
                name: 'Technician Assigned',
                completeTime: ''
            },
            {
                id: 3,
                name: 'Technician Scheduled',
                completeTime: ''
            },
            {
                id: 4,
                name: 'Technician On-Site',
                completeTime: ''
            },
            {
                id: 5,
                name: 'Completed',
                completeTime: ''
            }
        ]), steps = _c[0], setSteps = _c[1];
    var ih = isIH();
    var btnList = [
        {
            url: ih ? 'https://apps.apple.com/us/app/invitation-homes-maintenance/id1547390284' : 'https://apps.apple.com/us/app/one-maintenance/id1569281831',
            target: 'AppStore',
            eventName: ih ? AmplitudeEventName.NewRsp_IHClickAppStore : AmplitudeEventName.NewRsp_NoIHClickAppStore
        },
        {
            url: ih ? 'https://play.google.com/store/apps/details?id=com.starlight.mobile.app.client.ih' : 'https://play.google.com/store/apps/details?id=com.starlight.mobile.app.client.maintenance',
            target: 'GooglePlay',
            eventName: ih ? AmplitudeEventName.NewRsp_IHClickGooglePlay : AmplitudeEventName.NewRsp_NoIHClickGooglePlay
        }
    ];
    var woId = submitData.id;
    var isReactive = true;
    useEffect(function () {
        if (!woId)
            return;
        (function () {
            return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            getWoDetail(woId, isReactive)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4,
                            getIsEnableDTCConfig()
                        ];
                    case 2:
                        _a.sent();
                        setLoading(false);
                        return [2];
                    }
                });
            });
        }());
    }, [woId]);
    useEffect(function () {
        if (!woDetail)
            return;
        var data = [];
        var isScheduled = woDetail.StatusId === WOStatus.Scheduled;
        var _showStatusId = isScheduled ? ISubmitStatusId.TechnicianScheduled : ISubmitStatusId.RequestSubmitted;
        data = steps.map(function (x) {
            if (x.id === 1) {
                x.completeTime = woDetail.CreateDate;
            }
            if (x.name === 'Technician Assigned') {
                x.completeTime = woDetail.ScheduleStart;
            }
            return x;
        });
        setSteps(data);
        setCurrentStep(_showStatusId);
    }, [woDetail]);
    var sendAmplitude = function (eventName) {
        sendAmplitude_Default(eventName, {
            userId: currentUser.userId,
            residentId: currentUser.residentId,
            clientId: Cookies.get('clientId'),
            env: getCurrentEnv()
        });
    };
    var onSubmit = function () {
        sendAmplitude_Default(AmplitudeEventName.NewRSP_WOTimeLine, {
            userId: currentUser.userId,
            residentId: currentUser.residentId,
            clientId: Cookies.get('clientId'),
            env: getCurrentEnv()
        });
        history.push('/?isFromNewRequestSubmitted=true');
    };
    return React.createElement('div', { className: 'rsp-body' }, React.createElement('div', { className: 'rsp-step-header py-3' }, React.createElement('div', { className: 'rsp-step-back' }), React.createElement('h1', { className: 'rsp-step-title rest-step-title font-weight-bolder' }, 'Request submitted'), React.createElement('div', { className: 'rsp-step-back' })), React.createElement('div', { className: 'dsm-card' }, React.createElement('div', { className: 'dsm-card-body step-submitted-body' }, isRecallCheck && React.createElement('h1', { className: 'request-submitted-title font-weight-bolder pb-4' }, 'We will review the additional details to the new work order. '), React.createElement('h1', { className: 'request-submitted-title font-weight-bolder' }, 'We value transparency. Here\'s a look into the process.'), React.createElement('div', { className: 'rsp-progress-bar py-4' }, React.createElement('div', { className: 'rsp-step-progress' }, React.createElement('div', { className: 'c-walkthru' }, React.createElement('div', { className: 'dsm-walkthru dsm-walkthru-rsp dsm-walkthru-horizontal dsm-walkthru-auto-text' }, steps.map(function (item, index) {
        var renderTimeLine = function (item, index) {
            return React.createElement(React.Fragment, null, React.createElement('div', { className: 'dsm-walkthru-item ' + (index === currentStep ? 'dsm-walkthru-item-active' : 'dsm-walkthru-item-wait') }, React.createElement('div', { className: 'dsm-walkthru-item-time ' + (index !== currentStep ? 'opacity0' : '') }, React.createElement('h5', { className: 'font-weight-bolder mb-1' }, index === currentStep ? item.name : ''), currentStep !== ISubmitStatusId.TechnicianScheduled && React.createElement('div', { className: 'f12 text-center mb-1' }, 'You created'), React.createElement('div', { className: 'f12 text-muted mb-1' }, currentStep === ISubmitStatusId.TechnicianScheduled ? moment(woDetail.ScheduleStart).format('MMM DD/YYYY, h:mm A') + ' -' : moment(woDetail.createDate).format('MMM DD/YYYY, h:mm A')), currentStep === ISubmitStatusId.TechnicianScheduled && React.createElement('div', { className: 'f12 text-muted mb-1' }, moment(woDetail.ScheduleEnd).format('h:mm A'))), React.createElement('div', { className: 'dsm-walkthru-line' }), React.createElement('div', {
                className: 'dsm-walkthru-icon',
                'data-one-uiautomation': 'button.rspDoneProgress.steps.' + index
            }), React.createElement('div', { className: 'dsm-walkthru-tail' }, index !== currentStep && item.name)));
        };
        return React.createElement(React.Fragment, null, currentStep === ISubmitStatusId.TechnicianScheduled && React.createElement(React.Fragment, null, [
            0,
            1
        ].includes(index) && React.createElement('div', { className: 'dsm-walkthru-item dsm-walkthru-item-finished' }, React.createElement('div', { className: 'dsm-walkthru-item-time opacity0' }, React.createElement('h5', { className: 'font-weight-bolder mb-1' }), React.createElement('div', { className: 'f12 text-center mb-1' }), React.createElement('div', { className: 'f12 text-muted mb-1' })), React.createElement('div', { className: 'dsm-walkthru-line' }), React.createElement('div', {
            className: 'dsm-walkthru-icon',
            'data-one-uiautomation': 'button.rspDoneProgress.steps.' + index
        }), React.createElement('div', { className: 'dsm-walkthru-tail' }, item.name)), index > 1 && renderTimeLine(item, index)), currentStep === ISubmitStatusId.RequestSubmitted && renderTimeLine(item, index));
    }))))))), React.createElement(Button, {
        type: 'primary',
        className: 'dsm-btn-primary dsm-btn requested-submitted-btn',
        onClick: function () {
            return onSubmit();
        },
        tag: 'requestedSubmittedBtn'
    }, 'Done'), isMobile && !isDTC && React.createElement('div', { className: 'drainage' }, React.createElement('div', { className: 'drainage-title' }, 'Download the Resident Portal App!'), React.createElement('div', { className: 'drainage-content' }, 'Stay connected with the latest features and updates to your new work order.'), React.createElement('div', { className: 'd-flex justify-content-between' }, btnList.map(function (item) {
        return React.createElement('a', {
            href: item.url,
            target: '_blank',
            onClick: function () {
                sendAmplitude(item.eventName);
            }
        }, item.target === 'AppStore' ? React.createElement('img', { src: 'https://rsp-front-end-dev.lessen.com/sources/svg/appStore.svg' }) : React.createElement('img', { src: 'https://rsp-front-end-dev.lessen.com/sources/svg/googlePlay.svg' }));
    }))), React.createElement(Loader, {
        visible: loading,
        page: true
    }));
}));
export var ISubmitStatusId;
(function (ISubmitStatusId) {
    ISubmitStatusId[ISubmitStatusId['RequestSubmitted'] = 0] = 'RequestSubmitted';
    ISubmitStatusId[ISubmitStatusId['TechnicianScheduled'] = 2] = 'TechnicianScheduled';
}(ISubmitStatusId || (ISubmitStatusId = {})));
export default withRouter(CreateRequestSubmitted);